import React from 'react';
import Text from 'xpi-black-ui/Base/Typography/Text';
import styled from 'styled-components';

const Wrapper = styled.div`
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFC200;
  border-radius: 100%;
`;

const Title = styled(Text).attrs(() => ({ larger: true }))`
  color: black;
`;

export default function NumberBadge({ value }) {
  return (
    <Wrapper>
      <Title>{value}</Title>
    </Wrapper>
  );
}
